import React from "react";
import classes from "./ThreadListSkeletonLoader.scss";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import _ from "lodash";

const SingleLoadingItem = () => {
  return (
    <div className={classes.itemContainer}>
      <SkeletonLoader
        variant="rectangular"
        width="36px"
        height={36}
        customClasses={classes.skeletonRounded}
      />
      <div className={classes.skeletonLineContainer}>
        <SkeletonLoader height={12} width={"80%"} variant="rounded" />
        <SkeletonLoader width="100%" height={12} variant="rounded" />
      </div>
    </div>
  );
};

const items = Array.from({ length: 20 }, (_it, idx) => idx);

const ThreadListSkeletonLoader = () => {
  return (
    <div className={classes.container}>
      {_.map(items, item => (
        <SingleLoadingItem key={item} />
      ))}
    </div>
  );
};

ThreadListSkeletonLoader.propTypes = {};

export default ThreadListSkeletonLoader;
